const DEFAULT_SELECTOR_PER_PAGE = 100;

export const getSelectorPerPage = () => {
  const value = Number(localStorage.getItem('selector_per_page'));
  return Number.isFinite(value) && value > 0 ? value : DEFAULT_SELECTOR_PER_PAGE;
};
